module.exports = __webpack_public_path__ + "static/media/6.7d40e50f.jpg";